import './scripts/common';
import {onFind} from "./libs/@elements/init-modules-in-scope";
import {findIn} from "./libs/@elements/dom-utils";

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]', function (element) {
    new Popover(element, {})
});

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as scrollingArea from './scripts/scrolling-area';
scrollingArea.init();

import * as historySlider from './scripts/history-slider';
historySlider.init();

import * as rangeSlider from './libs/@elements/range-slider';
onFind('.js-range-slider', function (slider) {
    rangeSlider.createRangeSlider(slider, {
        onUpdate: (sliderObj) => {
            let value = sliderObj.value,
                decimalPlaces = sliderObj.decimalPlaces;

            if ( sliderObj.handle === 0 ) {
                findIn('.js-range-slider__slider [data-handle="'+ sliderObj.handle +'"]', slider).setAttribute('data-text', value);
            } else {
                findIn('.js-range-slider__slider [data-handle="'+ sliderObj.handle +'"]', slider).setAttribute('data-text', value);
            }
        },
        handleAttributes: [
            {'aria-label': translate('aria.slider.lower-value')},
            {'aria-label': translate('aria.slider.upper-value')},
        ],
        },

        {
            slider: '.js-range-slider__slider',
        inputMin: '.js-range-slider__min',
        inputMax: '.js-range-slider__max',
    });
});

import * as overlay from './scripts/overlay';
overlay.init();

import * as productGridFilter from './scripts/productGridFilter';
productGridFilter.init();

import * as productGrid from './libs/@elements/product-grid';
productGrid.init();

import * as loadBazaar from './scripts/load-bazaar';
loadBazaar.init();

import * as video from './scripts/video';
import {translate} from "../shared/translations/translations";
video.init();
